<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0 Registration-split">
    <app-account-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-account-header>

    <div class="row">
      <div class="col-12 leftmargin">
        <h3 class="pdp-title">
          {{ "accountRegistration.shippingInformation.title" | cxTranslate }}
        </h3>
        <span class="title-sub-heading">{{
          "accountRegistration.title_sub_heading" | cxTranslate
          }}</span>

        <div class="col-xs-12 col-sm-8 col-md-10 p0">
          <form [formGroup]="billingForm" id="billingAddressForm" (ngSubmit)="proceedToShipping()">
            <div id="registerBilling" formGroupName="billingAddress">
              <div class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  ">
                <ng-template #errorPopContent>{{
                  "accountRegistration.special_validation_msg_popover" | cxTranslate
                  }}</ng-template>

                <label for="facilityName" class="Fields-label icon-label">{{
                  "accountRegistration.form.facilityName.label" |
                  cxTranslate }}
                </label>
                <a placement="top" [ngbPopover]="errorPopContent"><img
                    src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" /></a>
                <input id="facilityName" name="facilityName" data-valid="valid_facility"
                  aria-labelledby="billingAddressForm.facilityName tooltipFacilityName" type="text" class="Fields-input"
                  formControlName="facilityName" data-di-id="#billingAddressForm.facilityName" maxlength="40" mdgTextFilter />

                <span *ngIf="
                      !!billingForm.get('billingAddress.facilityName').value &&
                      !billingForm.get('billingAddress.facilityName').valid &&
                      billingForm.get('billingAddress.facilityName').touched
                    " class="errorMessage">{{
                  "accountRegistration.alpha_numeric_msg" | cxTranslate
                  }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.facilityName').errors?.required &&
                      !billingForm.get('billingAddress.facilityName').valid &&
                      billingForm.get('billingAddress.facilityName').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>



              <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                <ng-template #errorPopContent>{{
                  "accountRegistration.special_validation_msg_popover" | cxTranslate
                  }}</ng-template>

                <label for="facilityName2" class="Fields-label icon-label">{{
                  "accountRegistration.form.facilityName2.label"
                  |
                  cxTranslate }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span>
                </label>
                <input id="facilityName2" name="facilityName2" data-valid="valid_facility"
                  aria-labelledby="billingAddressForm.facilityName tooltipFacilityName" type="text" class="Fields-input"
                  formControlName="facilityName2" maxlength="40" data-di-id="#billingAddressForm.facilityName" mdgTextFilter />

                <span *ngIf="
                  !!billingForm.get('billingAddress.facilityName2').value &&
                  !billingForm.get('billingAddress.facilityName2').valid &&
                  billingForm.get('billingAddress.facilityName2').touched
                " class="errorMessage">{{
                  "accountRegistration.alpha_numeric_msg" | cxTranslate
                  }}</span>
                <span *ngIf="
                  billingForm.get('billingAddress.facilityName2').errors?.required &&
                  !billingForm.get('billingAddress.facilityName2').valid &&
                  billingForm.get('billingAddress.facilityName2').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>








              <div class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    doubleLineContainer
                  ">
                <label for="formLegalName" class="Fields-label">{{ "accountRegistration.form.attention.label" |
                  cxTranslate
                  }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span>
                </label>
                <input id="attention" name="attention" data-valid="valid_facility" type="text" class="Fields-input"
                  formControlName="attention" maxlength="35" autocomplete="off" data-di-id="#formLegalName" mdgTextFilter />

                <span *ngIf="
              !!billingForm.get('billingAddress.attention').value &&
              !billingForm.get('billingAddress.attention').valid &&
              billingForm.get('billingAddress.attention').touched
            " class="errorMessage">{{
                  "accountRegistration.alpha_numeric_msg" | cxTranslate
                  }}</span>
                <span *ngIf="
              billingForm.get('billingAddress.attention').errors?.required &&
              !billingForm.get('billingAddress.attention').valid &&
              billingForm.get('billingAddress.attention').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>
              <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                <label for="billingAddressForm.line1" class="Fields-label icon-label">{{
                  "accountRegistration.form.address_line_1.label" | cxTranslate }}
                </label>
                <a placement="top" [ngbPopover]="errorPopContent">
                  <img src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" />
                </a>
                <input id="billingAddressForm.line1" name="billingAddress.line1" data-valid="valid_facility"
                  aria-labelledby="billingAddressForm.line1 tooltipBillingAddress1" type="text" class="Fields-input"
                  formControlName="line1" data-di-id="#billingAddressForm.line1" mdgTextFilter
                  googleAddress (addressChosen)="onAddress($event)" placeholder="Type address…" autocomplete="off"/>

                <span *ngIf="
                      !!billingForm.get('billingAddress.line1').value &&
                      !billingForm.get('billingAddress.line1').valid &&
                      billingForm.get('billingAddress.line1').touched
                    " class="errorMessage">{{
                  "accountRegistration.special_validation_msg" | cxTranslate
                  }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.line1').errors?.required &&
                      !billingForm.get('billingAddress.line1').valid &&
                      billingForm.get('billingAddress.line1').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                <label for="billingAddressForm.line2" class="Fields-label">{{
                  "accountRegistration.form.address_line_2.label" | cxTranslate
                  }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span></label>
                <input id="billingAddressForm.line2" name="billingAddressForm.line2" data-valid="valid_facility"
                  placeholder="Suite/Floor/Building" type="text" class="Fields-input field-optional"
                  formControlName="line2" data-di-id="#billingAddressForm.line2" mdgTextFilter />

                <span *ngIf="
                      !!billingForm.get('billingAddress.line2').value &&
                      !billingForm.get('billingAddress.line2').valid &&
                      billingForm.get('billingAddress.line2').touched
                    " class="errorMessage">{{ "accountRegistration.alpha_numeric_msg" | cxTranslate }}</span>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                <label for="billingAddressForm.town" class="Fields-label">{{
                  "accountRegistration.form.city.label" | cxTranslate
                  }}</label>
                <input id="billingAddressForm.town" name="billingAddressForm.town" data-valid="valid_city" type="text"
                  class="Fields-input" formControlName="town" data-di-id="#billingAddressForm.town" mdgTextFilter />

                <span *ngIf="
                      !!billingForm.get('billingAddress.town').value &&
                      !billingForm.get('billingAddress.town').valid &&
                      billingForm.get('billingAddress.town').touched
                    " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.town').errors?.required &&
                      !billingForm.get('billingAddress.town').valid &&
                      billingForm.get('billingAddress.town').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>
              <div class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  ">
                <label for="billingAddressForm.state" id="provinceLabel" class="Fields-label">{{
                  "accountRegistration.form.state.label" | cxTranslate
                  }}</label>
                <div class="">
                  <div class="pdp-dropdown" formGroupName="region">
                    <ng-select [items]="provinces" [searchable]="false" [clearable]="false" bindLabel="name"
                      bindValue="isocode" placeholder="Please select" formControlName="isocode" class="dropdown-credit">
                    </ng-select>
                  </div>
                  <span *ngIf="
                        billingForm.get('billingAddress.region.isocode').errors
                          ?.required &&
                        !billingForm.get('billingAddress.region.isocode').valid &&
                        billingForm.get('billingAddress.region.isocode').touched
                      " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                    "accountRegistration.requiredMsg"
                    | cxTranslate }}
                  </span>
                </div>
              </div>
              <div class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    zip-container
                  ">
                <label for="billingAddressForm.postalCode" class="Fields-label">{{
                  "accountRegistration.form.zipCode.label" | cxTranslate
                  }}</label>
                <input id="billingAddressForm.postalCode" name="billingAddressForm.postalCode"
                  data-valid="valid_zip_canada" maxlength="10" appZipMask type="text" class="Fields-input"
                  formControlName="postalCode" data-di-id="#billingAddressForm.postalCode" mdgTextFilter />

                <span *ngIf="
                      billingForm.get('billingAddress.postalCode').errors?.pattern &&
                      !billingForm.get('billingAddress.postalCode').valid &&
                      billingForm.get('billingAddress.postalCode').touched
                    " class="errorMessage" role="alert" aria-live="assertive">{{
                  "accountRegistration.PotalCode_Validation_msg"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.postalCode').errors?.required &&
                      !billingForm.get('billingAddress.postalCode').valid &&
                      billingForm.get('billingAddress.postalCode').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container small-device">
                <div class="phone-extension">
                  <div class="phone-container">
                    <label for="formPhone" class="Fields-label">{{
                      "accountRegistration.form.phone.label" | cxTranslate
                      }}</label>
                    <input id="formPhone" name="billingAddressForm.phone" data-valid="valid_phone"
                      placeholder="123-456-7890" maxlength="12" appPhoneMask type="text"
                      class="Fields-input phone-no-mask" formControlName="phone" autocomplete="off"
                      data-di-id="#formPhone" />

                    <span class="errorMessage" *ngIf="
                          !!billingForm.get('billingAddress.phone').value &&
                          !billingForm.get('billingAddress.phone').valid &&
                          billingForm.get('billingAddress.phone').touched
                        ">{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span>
                    <span *ngIf="
                          billingForm.get('billingAddress.phone').errors?.required &&
                          !billingForm.get('billingAddress.phone').valid &&
                          billingForm.get('billingAddress.phone').touched
                        " class="defaultMessage" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                  </div>
                  <div class="phone-container doubleLineContainer">
                    <label for="billingAddressForm.extension" class="Fields-label">{{
                      "accountRegistration.form.extension.label" | cxTranslate
                      }}<span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span></label>
                    <input id="billingAddressForm.extension" name="billingAddressForm.extension"
                      data-valid="valid_extension" type="text" class="Fields-input field-optional extension"
                      placeholder="-" (keyup)="validationExtension(billingForm.get('billingAddress.extension').value)"
                      formControlName="extension" maxlength="6" data-di-id="#billingAddressForm.extension" mdgTextFilter />
                    <span class="errorMessage" *ngIf="extensionErrorMsg">{{
                      "accountRegistration.form.extension.ext_validation_msg"
                      | cxTranslate
                      }}--{{extensionErrorMsg}}</span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                <label for="billingAddressForm.email" class="Fields-label">{{ "accountRegistration.form.email.label" |
                  cxTranslate }}
                </label>
                <input id="billingAddressForm.email" name="billingAddressForm.email" data-valid="valid_mail" type="text"
                  class="Fields-input" data-view="newemail" formControlName="email" data-charsfilter="email"
                  data-di-id="#billingAddressForm.email" mdgTextFilter />

                <span *ngIf="
                      !!billingForm.get('billingAddress.email').value &&
                      billingForm.get('billingAddress.email').invalid &&
                      billingForm.get('billingAddress.email').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "accountRegistration.form.email.email_validation_msg"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.email').errors?.required &&
                      !billingForm.get('billingAddress.email').valid &&
                      billingForm.get('billingAddress.email').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                <label for="billingAddressForm.confirmemail" class="Fields-label">{{
                  "accountRegistration.form.confirm_email.label" | cxTranslate }}
                </label>
                <input id="billingAddressForm.confirmemail" name="billingAddressForm.confirmemail"
                  data-valid="valid_mail" type="text" class="Fields-input" data-view="confirmemail" data-charsfilter="email"
                  formControlName="confirmEmail" data-di-id="#billingAddressForm.confirmemail" mdgTextFilter />

                <span *ngIf="
                      !!billingForm.get('billingAddress.confirmEmail').value &&
                      billingForm.get('billingAddress.confirmEmail').invalid &&
                      billingForm.get('billingAddress.confirmEmail').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{
                  "accountRegistration.form.email.email_validation_msg"
                  | cxTranslate
                  }}</span>

                <span *ngIf="
                      !!billingForm.get('billingAddress.confirmEmail').value &&
                      !billingForm.get('billingAddress.confirmEmail').invalid &&
                      billingForm.get('billingAddress.confirmEmail').value.toLowerCase() !==
                        billingForm.get('billingAddress.email').value.toLowerCase()
                    " class="errorMessage">{{
                  "accountRegistration.form.confirm_email.email_not_match"
                  | cxTranslate
                  }}</span>
                <span *ngIf="
                      billingForm.get('billingAddress.confirmEmail').errors?.required &&
                      !billingForm.get('billingAddress.confirmEmail').valid &&
                      billingForm.get('billingAddress.confirmEmail').touched
                    " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
              </div>

              <div class="
                    col-xs-12 col-sm-12 col-md-12
                    p0
                    Fields-container
                    asses_dropdown
                  ">
                <label for="billingAddressForm.practiceFacility" id="practiceFacilityLabel" class="Fields-label">{{
                  "accountRegistration.form.practice_or_facility_type.label"
                  | cxTranslate
                  }}</label>
                <div class="pdp-dropdown">
                  <div class="">
                    <ng-select [items]="practiceOrFacility" [searchable]="false" [clearable]="false" bindLabel="name"
                      bindValue="code" placeholder="Please select" formControlName="practiceOrFacilityType"
                      class="dropdown-credit shippingState"></ng-select>
                  </div>

                  <span *ngIf="
                        billingForm.get('billingAddress.practiceOrFacilityType').errors
                          ?.required &&
                        !billingForm.get('billingAddress.practiceOrFacilityType')
                          .valid &&
                        billingForm.get('billingAddress.practiceOrFacilityType').touched
                      " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                    "accountRegistration.requiredMsg"
                    | cxTranslate }}
                  </span>
                </div>
              </div>

              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  p0
                  Fields-container
                  asses_dropdown
                  ">

                <label for="orderCreationPlan" id="orderPlanLabel" class="Fields-label">{{
                  "accountRegistration.form.orderCreationPlan.label" | cxTranslate
                  }}</label>
                  <div class="pdp-dropdown">
                    <div class="">
                      <ng-select [items]="orderCreationPlans" [searchable]="false" [clearable]="false" bindLabel="name"
                        bindValue="code" placeholder="Please select" formControlName="orderCreationPlan"
                        class="dropdown-credit shippingState"></ng-select>
                    </div>
                    <span *ngIf="
                    billingForm.get('billingAddress.orderCreationPlan').errors?.required &&
                    !billingForm.get('billingAddress.orderCreationPlan').valid &&
                    billingForm.get('billingAddress.orderCreationPlan').touched
                    " class="errorMessage" role="alert" aria-live="assertive">{{
                      "userRegistration.userInformation.requiredMsg" | cxTranslate
                      }}
                    </span>
                  </div>
              </div>


              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  p0
                  Fields-container
                  doubleLineContainer
                ">
                    <label for="contractGroupName" class="Fields-label">{{
                      "accountRegistration.form.contractGroupName.label" | cxTranslate
                      }}
                    </label>
                    <input id="contractGroupName" name="contractGroupName" data-valid="valid_facility" maxlength="35"
                      aria-labelledby="contractGroupName tooltipFacilityName" type="text" class="Fields-input" autocomplete="off"
                      formControlName="contractGroupName" data-di-id="#contractGroupName" mdgTextFilter/>
                      <span *ngIf="
                      billingForm.get('billingAddress.contractGroupName').errors?.required &&
                      !billingForm.get('billingAddress.contractGroupName').valid &&
                      billingForm.get('billingAddress.contractGroupName').touched
                    " class="errorMessage" role="alert" aria-live="assertive">{{
                        "userRegistration.userInformation.requiredMsg" | cxTranslate
                        }}
                      </span>
              </div>

              <div class="row padTop">
                <div class="col-12">
                  <hr class="Fields-container-line billingPage" />

                  <label for="billingAddressForm.practiceFacility" id="practiceFacilityLabel"
                    class="Fields-label">{{"accountRegistration.form.receiving_hours.label" | cxTranslate}}</label>
                </div>
              </div>

              <span class="title-sub-heading col-xs-12 col-sm-12 col-md-12 p0">{{
                "accountRegistration.form.receiving_hour_text.label" | cxTranslate
                }}</span>


              <label for="billingAddressForm.practiceFacility" id="practiceFacilityLabel" class="Fields-label">{{
                "accountRegistration.form.delivery_hours.label"
                | cxTranslate
                }}</label>
              <span *ngIf="nodeliveryTime" class="errorMessage drop-downs" role="alert" aria-live="assertive"
                style="margin-bottom: 10px;">Please enter
                delivery Hours for below fields.</span>

              <div id="accountRegistrationDeliveryHours"
                class="col-xs-12 col-sm-12 col-md-9 col-lg-8 p0 dlvry-hrs-blk delHrsBcg">
                <div class="Delivery-Date-Common">
                  <label for="deliveryHours0.day" class="Delivery-Day">Monday</label><input id="deliveryHours0.Day"
                    name="deliveryHours[0].Day" type="hidden" value="MONDAY">
                  <div class="common-delivery-zone">
                    <div class="common-delivery-time d-flex pl-1 pr-1">
                      <span class="from-to-blk frm-blk">
                        <ng-select id="mondayFromTime" placeholder="Set Time" formControlName="mondayFromTime"
                          class="delTime" (change)="changeDeliverTime($event,'mondayToTime','mondayFromTime','from')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                      </span>

                      <span class="Delivery-Txt dlvry-to-lbl">to</span>
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="mondayToTime" class="delTime"
                          (change)="changeDeliverTime($event,'mondayFromTime','mondayToTime','to')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>

                        <div popoverClass="custPopOver" class="btn-outline-secondary" id="mondayBtn" placement="right"
                          ngbPopover="To-Time should be greater than From-Time">
                        </div>
                        <div id="falDiv"></div>
                        <span class="missing-time" *ngIf="displayMondayError">Missing Time</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="Delivery-Date-Common">
                  <span class="Delivery-Day">Tuesday</span>
                  <input id="deliveryHours1.Day" name="deliveryHours[1].Day" type="hidden" value="TUESDAY">
                  <div class="common-delivery-zone">
                    <div class="common-delivery-time d-flex pl-1 pr-1">
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="tuesFromTime" class="delTime"
                          (change)="changeDeliverTime($event,'tuesToTime','tuesFromTime','from')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                      </span>
                      <span class="Delivery-Txt dlvry-to-lbl">to</span>
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="tuesToTime" class="delTime"
                          (change)="changeDeliverTime($event,'tuesFromTime','tuesToTime','to')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                        <div id="tuesBtn" placement="right" ngbPopover="To-Time should be greater than From-Time">
                        </div>
                        <span class="missing-time" *ngIf="displayTuesError">Missing Time</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="Delivery-Date-Common">
                  <span class="Delivery-Day">Wednesday</span>
                  <input id="deliveryHours2.Day" name="deliveryHours[2].Day" type="hidden" value="WEDNESDAY">
                  <div class="common-delivery-zone">
                    <div class="common-delivery-time d-flex pl-1 pr-1">
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="wedFromTime" class="delTime"
                          (change)="changeDeliverTime($event,'wedToTime','wedFromTime','from')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                      </span>
                      <span class="Delivery-Txt dlvry-to-lbl">to</span>
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="wedToTime" class="delTime"
                          (change)="changeDeliverTime($event,'wedFromTime','wedToTime','to')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                        <div id="wedBtn" placement="right" ngbPopover="To-Time should be greater than From-Time">
                        </div>
                        <span class="missing-time" *ngIf="displayWedError">Missing Time</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="Delivery-Date-Common">
                  <span class="Delivery-Day">Thursday</span>
                  <input id="deliveryHours3.Day" name="deliveryHours[3].Day" type="hidden" value="THURSDAY">
                  <div class="common-delivery-zone">
                    <div class="common-delivery-time d-flex pl-1 pr-1">
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="thursFromTime" class="delTime"
                          (change)="changeDeliverTime($event,'thursToTime','thursFromTime','from')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                      </span>
                      <span class="Delivery-Txt dlvry-to-lbl">to</span>
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="thursToTime" class="delTime"
                          (change)="changeDeliverTime($event,'thursFromTime','thursToTime','to')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                        <div id="thursBtn" placement="right" ngbPopover="To-Time should be greater than From-Time">
                        </div>
                        <span class="missing-time" *ngIf="displayThursError">Missing Time</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="Delivery-Date-Common">
                  <span class="Delivery-Day">Friday</span>
                  <input id="deliveryHours4.Day" name="deliveryHours[4].Day" type="hidden" value="FRIDAY">
                  <div class="common-delivery-zone">
                    <div class="common-delivery-time d-flex pl-1 pr-1">
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="fridayFromTime" class="delTime"
                          (change)="changeDeliverTime($event,'fridayToTime','fridayFromTime','from')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                      </span>
                      <span class="Delivery-Txt dlvry-to-lbl">to</span>
                      <span class="from-to-blk frm-blk">
                        <ng-select placeholder="Set Time" formControlName="fridayToTime" class="delTime"
                          (change)="changeDeliverTime($event,'fridayFromTime','fridayToTime','to')">
                          <ng-option *ngFor="let timeval of timelist" [value]="timeval.id">{{timeval.name}}</ng-option>
                        </ng-select>
                        <div id="fridayBtn" placement="right" ngbPopover="To-Time should be greater than From-Time">
                        </div>
                        <span class="missing-time" *ngIf="displayFriError">Missing Time</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="Fields-container-line billingPage" />

               <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container padBot captcha-x">
              </div>
              <div class="invoice-btngrps">
                <button type="submit" class="btn-primary marginTop" data-di-id="di-id-7a6cb2cd-cb37948a">
                  {{ "accountRegistration.form.continue_button" | cxTranslate }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>





  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2" [innerHTML]="(finalNeedAss | async)?.content">
  </div>
</div>
